var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-row',[_c('mds-col',[_c('h1',{staticClass:"title",domProps:{"textContent":_vm._s(`${!_vm.$route.params.id ? 'Add' : 'Edit' } Provider`)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }